export const styles = {
  pageContainer: {
    background: "#f5f7fa",
    minHeight: "100vh",
    py: { xs: 6, md: 10 },
    fontFamily: "'Inter', sans-serif",
  },

  headerBox: {
    textAlign: "center",
    mb: { xs: 6, md: 8 },
    maxWidth: 700,
    mx: "auto",
  },

  title: {
    mb: 1,
    fontSize: { xs: "2rem", md: "2.5rem" },
    fontWeight: 700,
    fontFamily: "system-ui",
    color: "#1f2937",
    letterSpacing: "-0.5px",
  },

  subtitle: {
    mb: 5,
    fontSize: { xs: "1rem", md: "1.125rem" },
    color: "#4b5563",
    fontFamily: "system-ui",
    lineHeight: 1.6,
  },

  searchField: {
    mb: 4,
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      borderRadius: 8,
      fontSize: "0.9375rem",
      fontFamily: "system-ui",
      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      "&:hover fieldset": {
        borderColor: "#3b82f6",
      },
      "&.Mui-focused fieldset": {
        borderWidth: "2px",
        borderColor: "#3b82f6",
      },
    },
  },

  categoryStack: {
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    py: 1,
    px: 1,
    gap: 2, // spacing between chips
    "&::-webkit-scrollbar": {
      display: "none", // hide scrollbar
    },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },

  categoryChip: (isSelected) => ({
    flexShrink: 0, // prevents shrinking
    px: 1,
    height: 36,
    fontSize: "0.875rem",
    fontWeight: 500,
    fontFamily: "system-ui",
    border: "1px solid #bdbdbd",
    borderWidth: isSelected ? 0 : 1,
    borderColor: "#d1d5db",
    backgroundColor: isSelected ? "#1a365d" : "#f3f4f6",
    color: isSelected ? "#fff" : "#374151",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: isSelected ? "#1a365d" : "#e5e7eb",
      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      transform: "translateY(-1px)",
    },
  }),

  faqContainer: {
    maxWidth: 900,
    mx: "auto",
    maxHeight: 550,
    overflowY: "auto",
    // px: 1,
    // py: 1,
    // pr: 2,
    // borderRadius: 12,
    // boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    // backgroundColor: "#ffffff",
    // "&::-webkit-scrollbar": {
    //   width: "6px",
    // },
    "&::-webkit-scrollbar": {
      width: "6px",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(26, 54, 93, 0.4)",
      borderRadius: 3,
      transition: "background-color 0.2s ease",
    },

    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "rgba(26, 54, 93, 0.6)",
    },

    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f5f7fa",
      borderRadius: 3,
    },
  },

  accordion: (isExpanded) => ({
    mb: 2,
    borderRadius: "12px",
    overflow: "hidden",
    border: "1px solid",
    borderColor: isExpanded ? "#3b82f6" : "#e5e7eb",
    boxShadow: isExpanded
      ? "0 10px 25px rgba(59, 130, 246, 0.15)"
      : "0 2px 8px rgba(0,0,0,0.04)",
    transition: "all 0.3s ease",
    "&:before": { display: "none" },
  }),

  accordionSummary: {
    px: { xs: 3, md: 4 },
    py: 2.5,
    minHeight: 70,
    "&.Mui-expanded": {
      backgroundColor: "#eff6ff",
    },
  },

  categoryBadge: {
    mb: 1,
    height: 24,
    fontSize: "0.75rem",
    fontWeight: 600,
    backgroundColor: "#1a365d",
    color: "#fff",
    fontFamily: "system-ui",
  },

  questionText: {
    fontWeight: 600,
    fontFamily: "system-ui",
    color: "#111827",
    fontSize: "1.1rem",
  },

  accordionDetails: {
    px: { xs: 3, md: 4 },
    py: 3,
    backgroundColor: "#ffffff",
    borderTop: "1px solid #e5e7eb",
  },

  answerText: {
    color: "#4b5563",
    fontSize: "0.9375rem",
    lineHeight: 1.6,
  },

  noResultsPaper: {
    textAlign: "center",
    py: 10,
    px: 4,
    maxWidth: 500,
    mx: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    backgroundColor: "#fff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
  },

  noResultsIcon: {
    fontSize: 64,
    color: "#9ca3af",
    mb: 2,
  },

  noResultsTitle: {
    mb: 1,
    fontWeight: 600,
    color: "#111827",
  },

  contactPaper: {
    mt: { xs: 10, md: 10 },
    p: { xs: 3, md: 4 },
    borderRadius: 16,
    textAlign: "center",
    // backgroundColor: "#1e3a8a",
    background:
      "linear-gradient(135deg, rgb(26, 54, 93) 0%, rgb(45, 74, 124) 100%)",
    color: "#fff",
    maxWidth: 800,
    mx: "auto",
    position: "relative",
    overflow: "hidden",
  },

  contactTitle: {
    fontWeight: 600,
    mb: 1,
    fontSize: "1.5rem",
    fontFamily: "system-ui",
  },

  contactDescription: {
    mb: 3,
    lineHeight: 1.7,
    fontSize: "1rem",
  },

  contactDivider: {
    borderColor: "rgba(255,255,255,0.3)",
    mb: 4,
    maxWidth: 400,
    mx: "auto",
  },

  contactStack: {
    direction: { xs: "column", sm: "row" },
    spacing: 4,
    justifyContent: "center",
    alignItems: "center",
  },

  contactLabel: {
    opacity: 0.8,
    mb: 0.5,
    fontSize: "0.875rem",
    fontFamily: "system-ui",
  },

  contactValue: {
    fontWeight: 600,
    fontSize: "1rem",
    fontFamily: "system-ui",
  },

  expandIcon: {
    color: "#1e3a8a",
    fontSize: "1.25rem",
  },

  searchIcon: {
    color: "#9ca3af",
  },
};
